import { api } from '@/api';

export interface PostMatterDocumentBulkGetUploadRequest {
  matterId: string;
  fletchDocumentIds: string[];
}

export interface MatterDocumentUploadInfo {
  fletchDocumentId: string;
  uploadPath: string;
  uploadToken: string;
}

export interface PostMatterDocumentBulkGetUploadResponse {
  uploads: MatterDocumentUploadInfo[];
}

const matterDocumentBulkGetUploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterDocumentBulkGetUpload: builder.mutation<
      PostMatterDocumentBulkGetUploadResponse,
      PostMatterDocumentBulkGetUploadRequest
    >({
      query: (body) => ({
        url: '/matter/document-upload/bulk-get-upload',
        method: 'POST',
        body,
      }),
      /** Mutations don't retry by default, but this one only reads upload URLs, so it's safe to retry. */
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { usePostMatterDocumentBulkGetUploadMutation } = matterDocumentBulkGetUploadApi;
